import { PublicCartId } from '../types';
import { PublicCartShipping } from './public-cart-shipping';
import { PublicCartSummary } from './public-cart-summary';
import { PublicCartBillingAddress } from './public-cart-billing-address';
import { Nillable } from '@web/utils';
import { PublicCartShippingAddress } from './public-cart-shipping-address';
import { PublicCartRecursive } from './public-cart-recursive';
import { PublicCartDiscount } from './public-cart-discount';

export class PublicCartDetails {
  public constructor(
    private readonly data: {
      billingAddress: Nillable<PublicCartBillingAddress>;
      comment?: Nillable<string>;
      id: PublicCartId;
      otherShippingAddress?: Nillable<boolean>;
      recursive: PublicCartRecursive[];
      shipping: PublicCartShipping;
      shippingAddress: Nillable<PublicCartShippingAddress>;
      summary: PublicCartSummary;
      totalItems: number;
      discount: Nillable<PublicCartDiscount>;
    },
  ) {}

  public get id(): PublicCartId {
    return this.data.id;
  }

  public get totalItems(): number {
    return this.data.totalItems;
  }

  public get summary(): PublicCartSummary {
    return this.data.summary;
  }

  public get shipping(): PublicCartShipping {
    return this.data.shipping;
  }

  public get billingAddress(): Nillable<PublicCartBillingAddress> {
    return this.data.billingAddress;
  }

  public get shippingAddress(): Nillable<PublicCartShippingAddress> {
    return this.data.shippingAddress;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get otherShippingAddress(): Nillable<boolean> {
    return this.data.otherShippingAddress;
  }

  public get recursive(): PublicCartRecursive[] {
    return this.data.recursive;
  }

  public get discount(): Nillable<PublicCartDiscount> {
    return this.data.discount;
  }
}
